import React from "react";
import BatchTableContainer from "../../modules/OrganizationBatches/containers/BatchTableContainer/BatchTableContainer";

const BatchDetails = () => {
  return <BatchTableContainer />;
};

export default BatchDetails;
